import React from "react";
import { motion } from "framer-motion";
import { LogoMark } from "./LogoMark";

export default function PageHero({ overline, title, subtitle, image, testid = "page-hero" }) {
  return (
    <section data-testid={testid} className="relative pt-40 pb-24 md:pt-56 md:pb-32 overflow-hidden bg-ink-950 glow">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-[0.18]" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/85 to-ink-950/60" />
        </>
      )}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7 }}>
          <LogoMark className="h-12 w-12 mb-8" color="#7FA8C9" />
        </motion.div>
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}
          className="overline text-steel-light mb-5">{overline}</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-gradient text-4xl md:text-6xl lg:text-7xl leading-[1.05] max-w-4xl" style={{ fontWeight: 500 }}>
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.35 }}
            className="mt-8 text-white/60 text-lg md:text-xl leading-relaxed max-w-2xl font-300">{subtitle}</motion.p>
        )}
      </div>
    </section>
  );
}
